import UboForm from "./ubo-form";
import UboCard from "./ubo-card";
import React, { useState, useEffect } from "react";
import config from "../../config/form.json";
import useNotify from "../../utils/useNotify";
import { useNavigate } from "react-router-dom";
import SectionHeading from "./section-headings";
import { putUbo, getAllUBOs, getOrgsDetails } from "../../services/httpCalls";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { Typography, Form, Modal, Button, Radio, Col } from "antd";
import { handleNext } from "../../utils/onboarding/ubo/handle-next";
import { useRecoilValue, useRecoilState, useSetRecoilState } from "recoil";
import {
  orgmode,
  productSelection,
  showloader,
  notOps,
  uboFlag,
  declarations,
  inwardPartner,
} from "../../store/gloabalState";

const Ubo = ({ handleChange }) => {
  // initializing form
  const [form] = Form.useForm();

  // getting ubo parent config data
  const configData = config.ubo[1].uboParent[0];

  // local states
  const [refresh, setRefresh] = useState(false);
  const [editData, setEditData] = useState();
  const [editFlag, setEditFlag] = useState(false);
  const [tablemore25, setTableMore25] = useState();
  const [tableless25, setTableLess25] = useState();
  const [openModal, setOpenModel] = useState(false);
  const [refreshtable, setRefreshTable] = useState(false);
  const [requiredToSubmit, setRequiredToSubmit] = useState({
    ownership: false,
    declaration: false,
    ownwer25orless: false,
  });
  const [shareHoldersFetch, setShareHoldersFetch] = useState();

  // global states
  const partnerState = useRecoilValue(inwardPartner);

  // values
  const mode = useRecoilValue(orgmode);
  const notOps_ = useRecoilValue(notOps);
  const declarationFormValues = useRecoilValue(declarations);

  // setter/updater
  const setShowLoader = useSetRecoilState(showloader);

  // states
  const [uboValidated, setUboValidated] = useRecoilState(uboFlag);
  const [declationFrom, setDeclarationForm] = useRecoilState(declarations);
  const [selectionValue, setSelectionValue] = useRecoilState(productSelection);

  // constants/binders
  const notify = useNotify();
  let navigate = useNavigate();

  const { confirm } = Modal;

  const editUbo = (elem) => {
    setEditFlag(true);
    setEditData(elem);
    setOpenModel(true);
  };

  const next = async () => {
    await handleNext({
      setShowLoader,
      selectionValue,
      notOps_,
      navigate,
      handleChange,
      uboValidated,
      notify,
      declarationFormValues,
      partnerState,
    });
  };

  const renderField = (field, index) => {
    const { type, label, name, props, style, tooltip } = field;

    // * formatting rules
    field?.rules?.forEach((item) => {
      if (item?.pattern) {
        item.pattern = eval(item?.pattern);
      }
      if (item?.required) {
        item.required = eval(item?.required);
      }
      if (item?.validator) {
        item.validator = eval(item?.validator);
      }
    });

    switch (type) {
      case "Form.Item":
        return (
          <React.Fragment>
            <Form.Item
              label={label}
              name={name}
              rules={field?.rules}
              tooltip={tooltip}
              labelCol={field?.labelCol}
              required={eval(field?.required)}
            >
              {field?.children ? renderField(field?.children, 0) : null}
            </Form.Item>
            {field?.subFields
              ? field?.subFields.map((child, childIndex) =>
                  renderField(child, childIndex)
                )
              : null}
          </React.Fragment>
        );
      case "Typography.Text":
        return <Typography.Text>{field?.text}</Typography.Text>;
      case "Radio.Group":
        return (
          <Radio.Group
            onChange={eval(props?.onChange)}
            value={eval(props?.value)}
          >
            {field?.children?.map((child, childIndex) =>
              renderField(child, childIndex)
            )}
          </Radio.Group>
        );
      case "Radio":
        return (
          <Radio value={field?.value} style={field?.style}>
            {field?.label}
          </Radio>
        );
      case "SectionHeading":
        return (
          <SectionHeading
            style={field?.style}
            level={field?.level}
            heading={field?.heading}
            Col={field?.Col}
          />
        );
      default:
        return null;
    }
  };

  const getShareholdingPattern = async () => {
    setShowLoader(true);
    let orgId = localStorage.getItem("orgId");
    await getAllUBOs(orgId)
      .then((res) => {
        if (res !== "") {
          let finalUbo = [];
          if (res?.length) {
            finalUbo = res?.filter((val) => val?.status !== "DELETED");
            if (
              partnerState.includes("payglocal") &&
              finalUbo.length &&
              finalUbo.some((ubo) => !ubo?.nationality)
            ) {
              setUboValidated(false);
            } else if (finalUbo.length) {
              setUboValidated(true);
            }
          }
          setShareHoldersFetch(finalUbo);

          let sharholding25 = res.filter((val) => {
            if (val.percentage > 25) return val;
          });
          setTableMore25(sharholding25);
          let shareholdingless25 = res.filter((val) => {
            if (val.percentage < 25) return val;
          });
          setTableLess25(shareholdingless25);
          if (res) {
            setRequiredToSubmit({ ...requiredToSubmit, ownwer25orless: true });
          }
        } else {
          setRequiredToSubmit({ ...requiredToSubmit, ownwer25orless: false });
        }
      })

      .catch((err) => {
        console.log(err);
        notify.error("Failed to show details of share holders");
        setShowLoader(false);
      })
      .finally(() => {
        setShowLoader(false);
        setRefresh(false);
      });
  };

  const deleteUbo = async (elem) => {
    setShowLoader(true);
    let data = {
      status: "DELETED",
    };
    let orgId = localStorage.getItem("orgId");
    await putUbo(data, orgId, elem.id)
      .then((res) => {
        if (res) {
          if (res?.length === 0) {
            setShareHoldersFetch([]);
          }
          notify.success("Deleted UBO!");
          setRefresh(true);
        }
      })
      .catch(() => {
        notify.error("UBO not deleted! Found error!");
      })
      .finally(() => {
        setShowLoader(false);
      });
  };

  const showDeleteConfirm = (elem, val) => {
    confirm({
      title: `Are you sure delete this UBO (${elem.name})?`,
      icon: <ExclamationCircleFilled />,
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk: () => deleteUbo(elem),
      onCancel() {},
    });
  };

  useEffect(() => {
    getShareholdingPattern();
  }, [refresh, refreshtable]);

  useEffect(() => {
    let orgId = localStorage.getItem("orgId");
    getOrgsDetails(orgId).then((res) => {
      if (res) {
        if (res?.isOptInward && res?.isOptOutward) {
          setSelectionValue("both");
        } else if (res?.isOptInward && !res?.isOptOutward) {
          setSelectionValue("inward");
        } else {
          setSelectionValue("outward");
        }
        setDeclarationForm({
          hasSubstantialUSOwner: res?.hasSubstantialUSOwner,
          hasUSIncomeSource: res?.hasUSIncomeSource,
          hasUSPhoneNumber: res?.hasUSPhoneNumber,
          hasUSResidenceOrMailingAddress: res?.hasUSResidenceOrMailingAddress,
          inCareOfOrHoldMailUS: res?.inCareOfOrHoldMailUS,
          isIncorporatedInUSA: res?.isIncorporatedInUSA,
          isSubsidiaryOfUSCompany: res?.isSubsidiaryOfUSCompany,
          siToUS: res?.siToUS,
          taxableInUS: res?.taxableInUS,
          grantedPOA: res?.grantedPOA,
        });
      }
    });
  }, []);

  return (
    <div>
      <div className="heading-container">
        <div className="line-heading"></div>
        <div>
          <Typography.Title level={4}>
            Beneficiary Owner Details
          </Typography.Title>
          <Typography.Text>
            Please enter the details of all the individuals who own 10% or more
            shares. In case no individual owns 10% or more shares, please enter
            the details of two key management personnel (Managing Director, CEO,
            CFO, CXO etc.).
          </Typography.Text>
        </div>
      </div>
      <UboForm
        open={openModal}
        setOpen={setOpenModel}
        setRefresh={setRefresh}
        editFlag={editFlag}
        editData={editData}
        setEditFlag={setEditFlag}
      />
      <UboCard
        mode={mode}
        editUbo={editUbo}
        selectionValue={selectionValue}
        shareHoldersFetch={shareHoldersFetch}
        showDeleteConfirm={showDeleteConfirm}
      />
      {(selectionValue === "outward" ||
        selectionValue === "both" ||
        (Boolean(partnerState.length) &&
          !configData.notPartner.some((ele) =>
            partnerState.includes(ele)
          ))) && (
        <Form
          {...configData.formConfig}
          disabled={mode === "view" ? true : false}
        >
          {configData.fields.map((field, index) => {
            // conditional render
            const shouldRender = true;

            return (
              shouldRender && (
                <Col key={index} span={field?.Col ? field?.Col : 24}>
                  {renderField(field, index)}
                </Col>
              )
            );
          })}
          <div className="fixed_btn_wrap">
            <Button onClick={() => handleChange(4)}>Previous</Button>
            <Button
              type="primary"
              style={{ marginLeft: ".5rem" }}
              htmlType="submit"
              onClick={next}
            >
              Next
            </Button>
          </div>
        </Form>
      )}
      {selectionValue === "inward" && (
        <div className="fixed_btn_wrap">
          <Button onClick={() => handleChange(4)}>Previous</Button>
          <Button
            type="primary"
            style={{ marginLeft: ".5rem" }}
            htmlType="submit"
            onClick={next}
          >
            Next
          </Button>
        </div>
      )}
    </div>
  );
};

export default Ubo;
